export default "__VITE_ASSET__C3shY86z__"